import axios from 'axios';
import { useQuery, UseQueryOptions } from 'react-query';

import { QueryKeys } from '.';
import { AxiosUtils } from '../../utils';
import { ApplicationSetting } from '../../models';
import { CerebroApiEndpoints } from '../../utils/api';

export function useApplicationSettingsQuery(
	authToken: string,
	options?:
		| Omit<UseQueryOptions<ApplicationSetting[], unknown, ApplicationSetting[], any>, 'queryKey' | 'queryFn'>
		| undefined
) {
	return useQuery(QueryKeys.Lookups.ApplicationSettings, () =>
		AxiosUtils.getResponseData(
			axios.get<ApplicationSetting[]>(
				CerebroApiEndpoints.Absolute(CerebroApiEndpoints.Lookups.ApplicationSettings),
				{
					headers: {
						Authorization: `Bearer ${authToken}`,
					},
				}
			)
		)
	);
}
